import type { Currency } from '@weft/types';

export const FORMAT_PRICE_MAXIMUM_FRACTION_DIGITS = 2;
export const FORMAT_PRICE_MINIMUM_FRACTION_DIGITS = 2;

export function formatPrice(price: number, currency: Currency, maximumFractionDigits = FORMAT_PRICE_MAXIMUM_FRACTION_DIGITS, minimumFractionDigits = FORMAT_PRICE_MINIMUM_FRACTION_DIGITS): string {
  const [integerPart, fractionalPart = ''] = price.toString().split('.');
  const paddedFractionalPart = fractionalPart.padEnd(maximumFractionDigits, '0').slice(0, maximumFractionDigits);
  const formattedPrice = `${integerPart}.${paddedFractionalPart}`;

  return new Number(formattedPrice).toLocaleString('en-US', {
    style: 'currency',
    currency,
    currencyDisplay: undefined,
    minimumFractionDigits,
    maximumFractionDigits,
  });
}